import { ContentGroupTypeEnum } from './content-group-type.enum';

export class MessageConfigContent {
  id: number;
  content: string;
  contentGroupTypeId: ContentGroupTypeEnum;
  messageConfigTypeId: number;
}

export class MessageConfigContentQuery {
  messageConfigContent: MessageConfigContent[];
}
